// TODO: 假資料，換成真資料後，記得刪除
export const DUMMY_TICKET_DISTRIBUTIONS = [
  {
    _id: '666',
    ticketName: '春季活動半價券',
    issueDate: 1732636800000,
    startDate: 1735228800000,
    endDate: 1798300800000,
    recipients: {
      plans: [
        {
          label: '黑卡會員',
          value: '黑卡會員',
        },
      ],
      members: [
        {
          label: '0987878787 朴敘俊',
          value: '0987878787 朴敘俊',
        },
        {
          label: '0933999111 韓佳人',
          value: '0933999111 韓佳人',
        },
      ],
    },
    amount: 1,
  },
];
